import React from 'react';
import cn from 'classnames';
import { Scheme } from '../constants';
import style from './index.module.scss';
import UseResize from 'utils/hooks/useResize';
import Transition, { TProps } from 'components/transition';
interface Props {
  data: Array<Scheme> | undefined;
  className?: string;
  title?: string;
  mTitle?: string;
  type?: number;
  isBg?: boolean;
  noTitle?: boolean; // 文本中只存在描述
  bgImg?: string;
  mBgImg?: string;
}
const Index = (props: Props & Omit<TProps, 'children'>) => {
  const { animate = 'none', delay = 0, offset = 0, bgImg = '', mBgImg = '' } = props;
  const size = UseResize();
  return (
    <div className={cn(style.scheme, props.isBg && style.bg, props.className)} style={{ backgroundImage: `url(${size.width < 768 ? mBgImg ?? bgImg : bgImg})` }}>
      <Transition delay={delay} offset={offset} animate={animate}>
        <div
          className={'title'}
          dangerouslySetInnerHTML={{
            __html: props.title?.replace(/\n/g, '<br>') || '解决方案',
          }}
        ></div>
      </Transition>
      <Transition delay={delay} offset={offset} animate={animate}>
        <div
          className={'mobTitle'}
          dangerouslySetInnerHTML={{
            __html: (props.mTitle ? props.mTitle : props.title || '')?.replace(/\n/g, '<br>'),
          }}
        ></div>
      </Transition>
      {props.noTitle && size.width < 768 ? (
        <div className={'scheme-wrap'}>
          {props.data?.map((item: any) => {
            return (
              <div key={item.title} className={`scheme-item`}>
                <Transition delay={delay + 0.3} offset={offset} animate={animate}>
                  <div style={{ backgroundImage: `url(${item.mUrl})` }} className="img-wrapper-m"></div>
                </Transition>
                <Transition delay={delay + 0.6} offset={offset} animate={animate}>
                  <div
                    className="scheme-item-title"
                    dangerouslySetInnerHTML={{
                      __html: item.title?.replace(/\n/g, '<br>'),
                    }}
                  ></div>
                </Transition>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={`content grid-${props.type}`}>
          {props.data?.map((item: any) => {
            return (
              <div key={item.title} className={`scheme-item`}>
                <Transition delay={delay + 0.3} offset={offset} animate={animate}>
                  <img src={item.pcUrl} className="img-wrapper" alt="" />
                  <img src={item.mUrl ?? item.pcUrl} className="img-wrapper-m" alt="" />
                </Transition>
                <Transition delay={delay + 0.6} offset={offset} animate={animate}>
                  <div className="scheme-item-content">
                    <div
                      className={cn('scheme-item-title', 'for-pc')}
                      dangerouslySetInnerHTML={{
                        __html: item.title?.replace(/\n/g, '<br>'),
                      }}
                    ></div>
                    <div
                      className={cn('scheme-item-title', !item.desc && 'scheme-item-title-normal', 'for-mobile')}
                      dangerouslySetInnerHTML={{
                        __html: (item.mTitle ? item.mTitle : item.title || '')?.replace(/\n/g, '<br>'),
                      }}
                    ></div>
                    {item.desc && (
                      <div
                        className="scheme-item-desc"
                        dangerouslySetInnerHTML={{
                          __html: item.desc?.replace(/\n/g, '<br>'),
                        }}
                      ></div>
                    )}
                  </div>
                </Transition>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Index;
